import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

import type { InParkingCardDetail } from 'src/features/cards/types/card';

const RESOURCE = '/parkings/:parkingId/cards/in-parking/:cardId/change-plan/';

type ChangePricingPlanCardFnType = typeof changePricingPlanCard;

type ChangePricingPlanCardDTO = {
    parkingId: string;
    cardId: number;
    pricing_plan_id: string;
};

const changePricingPlanCard = ({
    parkingId,
    cardId,
    ...data
}: ChangePricingPlanCardDTO): Promise<InParkingCardDetail> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId, cardId }), data);
};

interface UseChangePricingPlanCardOptions extends MutationConfig<ChangePricingPlanCardFnType, GeneralSmartParkError> {}

const useChangePricingPlanCard = (options: UseChangePricingPlanCardOptions = {}) =>
    useMutation({
        mutationFn: changePricingPlanCard,
        ...options,
    });

export { useChangePricingPlanCard, changePricingPlanCard, type ChangePricingPlanCardDTO, RESOURCE };
